export const defaultBannerBarData = {
    dateStart: null,
    dateEnd: null,
    orderBy: '1',
    file: '',
    navigationLink: '',
    subText: '',
}
